import { CSSProperties } from 'styled-components';

export const LoadingPanel: CSSProperties = {
    position: 'absolute',
    top: '50px',
    left: '0',
    right: '0',
    backgroundColor: '#fff',
};

export const LoadingIcon: CSSProperties = {
    color: 'transparent',
    borderTop: '3px solid rgba(0, 0, 0, 0)',
    borderBottom: '3px solid #06d2a9',
    borderLeft: '3px solid #06d2a9',
    animation: `rotate 1.1s infinite linear`,
    borderRadius: '50%',
    display: 'block',
    margin: 'auto',
    width: '30px',
    height: '30px',
};

export const LoadingText: CSSProperties = {
    textAlign: 'center',
    margin: '10px auto',
};
